// ============================================================
// INDUSTRIES — packaging applications displayed on /industries
// ============================================================
// These are neutral APPLICATION categories, not confirmed
// customer industries. Edit or add entries as needed.
// ============================================================

export const industries = [
  {
    id: "manufacturing",
    name: "Manufacturing",
    description: "General manufacturing environments requiring packaging for finished goods and components.",
  },
  {
    id: "automotive-components",
    name: "Automotive & Components",
    description: "Packaging for component storage, in-plant handling and dispatch.",
  },
  {
    id: "engineering",
    name: "Engineering",
    description: "Packaging for engineered assemblies and equipment.",
  },
  {
    id: "electronics",
    name: "Electronics",
    description: "Protective packaging for static- and moisture-sensitive components.",
  },
  {
    id: "warehousing-logistics",
    name: "Warehousing & Logistics",
    description: "Pallets, load-securing and handling materials for warehousing operations.",
  },
  {
    id: "industrial-packaging",
    name: "General Industrial Packaging",
    description: "Broad industrial packaging applications across sectors.",
  },
];
